import { render } from "./TableSimpleValue.vue?vue&type=template&id=afa08d66&scoped=true"
import script from "./TableSimpleValue.vue?vue&type=script&lang=js"
export * from "./TableSimpleValue.vue?vue&type=script&lang=js"

import "./TableSimpleValue.vue?vue&type=style&index=0&id=afa08d66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa08d66"]])

export default __exports__